import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/constants/Color';

const useStyles = makeStyles(() => ({
  tabBar: {
    display: 'inline-flex',
    gap: 4,
    backgroundColor: COLORS.background,
    borderRadius: 999,
    padding: 4,
    marginTop: 0,
  },
  tab: {
    padding: '4px 12px',
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background-color 0.15s, color 0.15s',
    border: 'none',
    color: COLORS.mediumgrey,
    backgroundColor: 'transparent',
    '&:hover': {
      color: '#1E293B',
    },
  },
  tabActive: {
    backgroundColor: `${COLORS.primary} !important`,
    color: `${COLORS.white} !important`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
  },
}));

interface Props {
  keys: readonly string[];
  active: string;
  onChange: (key: string) => void;
  getLabel: (key: string) => string;
}

const TimePeriodTabs = ({
  keys, active, onChange, getLabel,
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.tabBar}>
      {keys.map((key) => (
        <button
          key={key}
          type="button"
          className={[classes.tab, active === key ? classes.tabActive : ''].join(' ')}
          onClick={() => onChange(key)}>
          {getLabel(key)}
        </button>
      ))}
    </div>
  );
};

export default TimePeriodTabs;
